import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ProjectService} from '../../../../shared/services/project/project.service';
import {AlarmsEdasTypes} from '../../../../shared/types/edas-alarms.type';
import EdasAlarms = AlarmsEdasTypes.EdasAlarms;

@Component({
  selector: 'app-project-edas-alarms',
  templateUrl: './project-edas-alarms.component.html',
  styleUrls: ['./project-edas-alarms.component.css']
})
export class ProjectEdasAlarmsComponent implements OnInit {

  @Input('projectId') projectId: number = null;

  public showSpinner: boolean = false;

  public projectEdasAlarms: EdasAlarms[] = [];

  constructor(
    private projectService: ProjectService
  ) {
  }

  ngOnInit(): void {
    this.initList();
  }

  private initList() {

    if (!isNaN(this.projectId)) {
      this.showSpinner = true;
      this.projectService.getProjectEdasAlarms(this.projectId)
        .subscribe(
          (projectEdasAlarms: any) => {
            this.projectEdasAlarms = projectEdasAlarms;
            this.showSpinner = false;
          },
          (error2) => {
            this.showSpinner = false;
          }
        );
    } else {
      this.projectId = null;
    }

  }

}
